<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M19 2C20.5949 2 21.9035 3.25157 21.9949 4.82401L22 5V15C22 16.5949 20.7484 17.9035 19.176 17.9949L19 18H15.5L12.8 21.6C12.611 21.852 12.315 22 12 22C11.7244 22 11.4633 21.8867 11.2757 21.6895L11.2 21.6L8.5 18H5C3.40507 18 2.09654 16.7484 2.0051 15.176L2 15V5C2 3.40507 3.25157 2.09654 4.82401 2.0051L5 2H19ZM19 4H5C4.48836 4 4.06466 4.38715 4.00675 4.88362L4 5V15C4 15.5116 4.38715 15.9353 4.88362 15.9933L5 16H9C9.27563 16 9.5367 16.1133 9.72428 16.3105L9.8 16.4L12 19.333L14.2 16.4C14.3654 16.1795 14.6127 16.0386 14.8829 16.0069L15 16H19C19.5116 16 19.9353 15.6129 19.9933 15.1164L20 15V5C20 4.48836 19.6129 4.06466 19.1164 4.00675L19 4ZM17 11C17.552 11 18 11.448 18 12C18 12.5126 17.6137 12.9355 17.1166 12.9933L17 13H7C6.448 13 6 12.552 6 12C6 11.4874 6.38629 11.0645 6.88343 11.0067L7 11H17ZM17 7C17.552 7 18 7.448 18 8C18 8.51257 17.6137 8.93547 17.1166 8.99327L17 9H7C6.448 9 6 8.552 6 8C6 7.48743 6.38629 7.06453 6.88343 7.00673L7 7H17Z"
    fill="currentColor"
  />
</svg>
